// Keep public culture-service URLs stable while Shopify resolves the assigned template internally.
const advisorPaths = new Set([
  "/pages/five-elements-consultation",
  "/pages/five-elements-profile",
  "/pages/five-elements-reading",
  "/pages/bazi-consultation",
  "/pages/bazi-profile",
  "/pages/home-feng-shui-consultation",
  "/pages/home-feng-shui-profile",
]);

/* Determine whether a pathname is a fixed culture-service entry; input is a pathname and output is a boolean. */
function isAdvisorPath(pathname) {
  return advisorPaths.has(pathname.replace(/\/$/, ""));
}

document.addEventListener("DOMContentLoaded", () => {
  /* Open only the three fixed culture-service entries in a safe new tab; input is each storefront link and no value is returned. */
  document.querySelectorAll("a[href]").forEach((link) => {
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && isAdvisorPath(url.pathname)) {
      url.searchParams.delete("view");
      link.href = `${url.pathname}${url.search}${url.hash}`;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
    }
  });
});
